module.exports = __webpack_public_path__ + "img/cart-gateway3.55e996da.png";